import { render } from "./talech-service.vue?vue&type=template&id=1b5267c6"
import script from "./talech-service.vue?vue&type=script&lang=js"
export * from "./talech-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__